import { put, takeLatest } from 'redux-saga/effects';
import { GenSN } from '../../reducers/r_index';

import authService from './../../components/api-authorization/AuthorizeService';

// worker saga: makes the api call when triggerAction sees the action
export function* runAction({ payload: { anno } }) {
    try {
        const token = yield authService.getAccessToken();

        const response = yield fetch('/Licenses/GenSN/' + anno , {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });


        const sn_quattro_cifre = yield response.text();

        yield put(GenSN.creators.genSNSuccess({ sn_quattro_cifre }));

    } catch (e) {
        yield put(GenSN.creators.genSNFailed(e.message)); // failed to fetch data
    }
}

// watcher saga: watches for actions dispatched to the store, starts runAction
export function* triggerAction() {
    yield takeLatest(GenSN.types.GEN_SN_REQUEST, runAction);
}